<template>
<!-- 装修必看 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :model="filters" class="findform">
        <el-form-item label="关键词：" style="display:flex;width:25%">
          <el-input v-model="filters.channelName" placeholder="请输入内容 (10字以内)" maxlength="10" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="类型：" style="display:flex;width:25%;" class="select">
          <el-select v-model="filters.stateWithdrawal" filterable placeholder="请选择" style="width:90%;">
            <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>

  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">装修必看</p>
      <div style="float: right;margin-right: 10px;">
        <el-button type="danger" @click="endDeletegood()">批量删除</el-button>
        <el-button type="danger" @click="endToExamine()">新增</el-button>
      </div>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="guessYouLikeitList" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"/>
        <el-table-column label="序号" align="center" width="60px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="类型" align="center" width="180px">
          <template scope="scope">
            <span :title="scope.row.contentTypeName">{{scope.row.contentTypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品标题" align="center">
          <template scope="scope">{{scope.row.title}}</template>
        </el-table-column>
        <el-table-column label="排序" align="center" width="180px">
          <template scope="scope">{{scope.row.sort}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="220px">
          <template scope="scope">
            <span class="handle" @click="handleModifySort(scope.row)"><i class="el-icon-sort"></i> 修改排序 </span>
            <span class="handle" @click="singleDeletion(scope.row)"><i class="el-icon-delete"></i> 删除 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>

  <!-- 添加产品-弹框 -->
  <el-dialog title="添加产品" :visible.sync="isToExamine" :center="true" width="40%">
    <el-form style="display:flex">
      <el-form-item style="display:flex;width:50%;margin-right:10px">
        <el-input v-model="KeywordName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="handleSearch()">搜 索</el-button>
      </el-form-item>
    </el-form>

    <div>
      <div class="divNav">
        <span v-for="(item,index) in typeNameList" :key="index" @click="handleClick(item)" class="spanItem"
          :class="{spanItemRed: activeName == item.Id}">{{item.Name}}</span>
      </div>
      <div class="disoutline" v-infinite-scroll="loadchanpin">
        <div class="disinline" v-for="(item,index) in desarr" :key="index">
          <div class="dlStyle">
            <div class="dtDiv"><img class="dtImage" :src="item.coverImg"/></div>
            <div class="ddDiv">
              <b>{{item.title}}</b>
            </div>
          </div>
          <div class="confirmBtn" :class="{noPrice: activeName != 4}">
            <p v-if="activeName == 4">价格: <strong>{{item.promotionPrice}} 元</strong></p>
            <el-button @click="makedes(item)">添 加</el-button>
          </div>
        </div>
        <p style="text-align:center" v-show="nofind">查无结果</p>
        <p style="text-align:center" v-show="noMore">没有更多了</p>
      </div>
    </div>

  </el-dialog>

  <!-- 排序-弹框 -->
  <el-dialog title="排序" :visible.sync="sortPopup" class="add_order_cancle" width="30%" center>
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="SortValue" placeholder="请输入排序" maxlength="20" type="text"
        onkeyup="this.value=this.value.replace(/\D/g,'')"
        onafterpaste="this.value=this.value.replace(/\D/g,'')"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="sortPopup = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="editSubmit()"
        class="el-button el-button--default search_btn normal_btn">修改</button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getGuessYouLike, putGuessYouLike, getKeyword, postGuessYouLike, deleteGuessYouLike } from "../../api/comment";
export default {
  name: 'guessYouLikeIt',
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      likeId: "", // id
      likeSort: "", // 排序值
      guessYouLikeTheProductArr:[], // 复选框选中项
      guessYouLikeitList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        channelName: "", // 关键词
        stateWithdrawal: 0, // 类型
      },
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },{
          Id: 1,
          Name: "文章"
        },{
          Id: 2,
          Name: "视频"
        },{
          Id: 3,
          Name: "品牌店"
        },{
          Id: 4,
          Name: "特价商品"
        },{
          Id: 5,
          Name: "活动"
        },{
          Id: 6,
          Name: "直播回看"
        },{
          Id: 7,
          Name: "直播预约"
        }
      ],
      isToExamine: false, // 添加产品 - 弹框
      
      desarr: [],
      KeywordName: "", // 搜索内容
      activeName: 1, // 类型
      typeNameList: [
        {
          Id: 1,
          Name: "文章"
        },
        {
          Id: 2,
          Name: "视频"
        },
        {
          Id: 3,
          Name: "品牌店"
        },
        {
          Id: 4,
          Name: "特价商品"
        },
        {
          Id: 5,
          Name: "活动"
        },
        {
          Id: 6,
          Name: "直播回看"
        },
        {
          Id: 7,
          Name: "直播预约"
        }
      ],
      productPageIndex: 1,
      productPageSize: 10,
      productRowsCount: 0,
      productTitle: "", // 标题
      nofind: false, // 查无结果
      noMore: false, // 没有更多
      
      sortPopup: false, // 排序-弹框
      SortValue: "", // 排序值

    }
  },
  methods: {
    //查询列表
    getInit() {
      let addParams = {
        Keyword: this.filters.channelName, // 关键词
        MediaType: this.filters.stateWithdrawal, // 类型
        PageIndex: this.pageIndex,// 当前页码
        PageSize: this.pageSize // 每页显示条数
      };
      getGuessYouLike(addParams).then(data => {
        this.guessYouLikeitList = data.resultObj.resultObj;
        this.totalRowsCount = data.resultObj.rowsCount;
      }).catch(err => {
        this.guessYouLikeitList = [];
        this.totalRowsCount = 0;
      });
    },
    // + 添加
    endToExamine() {
      this.isToExamine = true;
      this.KeywordName = ""; // 清空搜索内容
      this.desarr = []; // 清空产品
      this.nofind = true;
      this.noMore = false;
      this.activeName = 1; // 类型重置为1
      this.productPageIndex = 1;
    },
    // 搜 索
    handleSearch() {
      this.nofind = false;
      this.noMore = false;
      this.productPageIndex = 1;
      this.desarr = [];
      this.finddes();
    },
    // 查询产品列表
    finddes() {
      var obj = {
        MediaType: this.activeName, // 类型
        Keyword: this.KeywordName, // 关键字
        PageIndex: this.productPageIndex,
        PageSize: this.productPageSize
      };
      getKeyword(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.desarr = this.desarr.concat(data.resultObj.resultObj);
            this.productRowsCount = data.resultObj.rowsCount;
            this.nofind = false;
            this.noMore = false;
          } else {
            if(this.productPageIndex == 1) {
              this.nofind = true;
            } else {
              this.noMore = true;
            }
          }
        } else {
          if(this.productPageIndex == 1) {
            this.nofind = true;
          } else {
            this.noMore = true;
          }
        }
      });
    },
    // 切换:类型
    handleClick(val) {
      this.nofind = false;
      this.noMore = false;
      this.activeName = val.Id;
      this.productPageIndex = 1;
      this.desarr = [];
      this.finddes();
    },
    loadchanpin() {
      if(this.desarr.length == 0) {return}
      this.productPageIndex += 1;
      this.finddes();
    },
    // 添加产品
    makedes(val) {
      this.productTitle = val.title; // 标题
      var obj = {
        userId: localStorage.Id,
        title: this.productTitle, // 标题
        contentType: this.activeName, // 类型: 1=文章；2=视频；3=品牌店；4=特价商品，5=活动；6=直播回看；7=直播预约
        id: val.id, // 选择项的id，随列表返回
      };
      postGuessYouLike(obj).then(data => {
        if (data.resultCode == 1) {
          this.isToExamine = false;
          this.showAlert(data.resultMsg, 'success');
          this.getInit();
        }
      });
    },
    // 点击排序
    handleModifySort(row) {
      this.likeId = row.id;
      this.likeSort = row.sort;
      this.SortValue = this.likeSort;
      this.sortPopup = true;
    },
    // 保存排序
    editSubmit() {
      if(this.SortValue == ""){
        this.showAlert('请输入排序值');
        return false;
      }
      // if (this.SortValue < 0 || this.SortValue > 100) {
      //   this.showAlert('请输入0到100的数字');
      //   return false;
      // }
      var loginParams = {
        id: this.likeId, // id
        sort: this.SortValue, // 排序值
      };
      putGuessYouLike(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.showAlert('修改成功');
        } else if(data.ResultCode == 4) {
          this.showAlert('无数据');
        } else {
          this.showAlert(data.ResultMsg);
        }
        this.sortPopup = false;
        this.getInit();
      })
    },
    // 批量删除
    endDeletegood(){
      if(this.guessYouLikeTheProductArr.length == 0){
        this.showAlert('请选择需要删除的数据');
        return false;
      }
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = this.guessYouLikeTheProductArr
          deleteGuessYouLike(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert(data.resultMsg, 'success');
              this.getInit()
            }
          })
        }
      })
    },
    // 单条删除-列表数据
    singleDeletion(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = [row.id]
          deleteGuessYouLike(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert(data.resultMsg, 'success');
              this.getInit();
            }
          })
        }
      })
    },
    // 复选框
    handleSelectionChange(val) {
      this.guessYouLikeTheProductArr = [];
      val.forEach(element => {
        this.guessYouLikeTheProductArr.push(element.id);
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        channelName: "", // 关键词
        stateWithdrawal: 0, // 类型
      }
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
  },
  created() {
    this.getInit(); // 查询列表
  }
}
</script>
<style scoped>
  .disoutline {
    max-height:245px;
    overflow: auto;
    height: auto;
    border: 1px solid #eee;
    padding: 10px;
  }
  .disinline {
    height: 100px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }
  .dlStyle {
    width: 70%;
    margin: 0 auto;
    float: left;
  }
  .dtDiv {
    width: 30%;
    float: left;
  }
  .ddDiv {
    width: 70%;
    height: 90px;
    float: left;
  }
  .ddDiv b {
    width: 100%;
    line-height: 50px;
    display: inline-block;
  }
  /* 图片 */
  .dtImage {
    width: 90%;
    height: 90px;
  }
  .divNav {
    width: 88%;
    height: 33px;
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
  }
  .spanItem {
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
  }
  .spanItemRed {
    color: #F56C6C;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }
  /* 添加按钮区域 */
  .confirmBtn {
    width: 30%;
    float: right;
    text-align: center;
  }
  .noPrice {
    margin-top: 25px;
  }
</style>


// WEBPACK FOOTER //
// guessYouLikeIt.vue?6ad0a9a4